// Physician-demo access keys — admin-gated ops on adminApi (functions/admin.mjs
// demoAccess*). A key is the credential for console /demo; create one per doctor,
// label it, give it an expiry, revoke it when the demo is over.
import { callAdmin } from './adminApi';

export interface DemoKeyRow {
  key: string;            // formatted XXXX-XXXX-XXXX
  label: string;
  note: string;
  dataset: string;
  datasetLabel: string;
  createdAt: number;      // ms epoch
  createdBy: string;
  expiresAt: number;      // 0 = never
  revokedAt: number;      // 0 = active
  uses: number;
  lastUsedAt: number;
  lastIp: string;
}

export const listDemoKeys = () => callAdmin<{ rows: DemoKeyRow[]; datasets: Record<string, string> }>('demoAccessList');
export const createDemoKey = (body: { label: string; note?: string; expiresDays?: number; dataset?: string }) =>
  callAdmin<{ key: string; expiresAt: number }>('demoAccessCreate', body);
export const revokeDemoKey = (key: string) => callAdmin('demoAccessRevoke', { key });
export const restoreDemoKey = (key: string) => callAdmin('demoAccessRestore', { key });
export const deleteDemoKey = (key: string) => callAdmin('demoAccessDelete', { key });

export const DEMO_URL = 'https://console.health.dreamgiga.ai/demo/';       // the patient app, demo mode
export const TRACKER_URL = 'https://console.health.dreamgiga.ai/tracker';   // physician tracking dashboard
export const demoLink = (key: string) => `${DEMO_URL}?key=${encodeURIComponent(key)}`;
export const trackerLink = (key: string) => `${TRACKER_URL}?key=${encodeURIComponent(key)}`;
export type KeyState = 'active' | 'expired' | 'revoked';
export const keyState = (r: DemoKeyRow): KeyState => (r.revokedAt ? 'revoked' : r.expiresAt && r.expiresAt < Date.now() ? 'expired' : 'active');
